import { directive } from "lit-html"

const ref = directive((refInstance) => (part) => {
  refInstance.current = part.element
})

export { ref }
